import { useState } from 'react';
import { useNavigate } from "@tanstack/react-location";
import { Auth } from "../../model/App/Firebase";
import {
    createStyles,
    LoadingOverlay,
    Alert,
    Paper,
    Title,
    Text,
    TextInput,
    Button,
    Container,
    Group,
    Anchor,
    Center,
    Box,
  } from '@mantine/core';
  import { IconArrowLeft } from '@tabler/icons';
  
  const useStyles = createStyles((theme) => ({
    title: {
      fontSize: 26,
      fontWeight: 900,
      fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    },
  
    controls: {
      [theme.fn.smallerThan('xs')]: {
        flexDirection: 'column-reverse',
      },
    },
  
    control: {
      [theme.fn.smallerThan('xs')]: {
        width: '100%',
        textAlign: 'center',
      },
    },
  }));
  
  export default function ForgotPasswordScreen() {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [email, setEmail] = useState<string>("");
    const [errorMessage, setErrorMessage] = useState<string>("");
    const { classes } = useStyles();
    const navigate = useNavigate();

    // "Reset Password" button...
    const onResetPasswordPress = () => {
        setIsLoading(true);
        setErrorMessage("");

        Auth.sendPasswordResetEmail(email)
            .then(() => {
                setIsLoading(false);
                setErrorMessage("Password reset email has been sent.");
            }, (error) => {
                setIsLoading(false);
                setErrorMessage(error.message);
            });
    }
  
    return (
      <Container size={460} my={30}>
        <Title className={classes.title} align="center">
          Forgot your password?
        </Title>
        <Text color="dimmed" size="sm" align="center">
          Enter your email to get a reset link
        </Text>
  
        <LoadingOverlay visible={isLoading} />
        <Paper withBorder shadow="md" p={30} radius="md" mt="xl">
          <TextInput label="Your email" placeholder="aaron@aestradalegal.com" required 
             value={email}
             onChange={(event) => { setEmail(event.target.value); }}
          />
          <Group position="apart" mt="lg" className={classes.controls}>
            <Anchor color="dimmed" size="sm" className={classes.control} onClick={() => navigate({ to: "/login" })}>
              <Center inline>
                <IconArrowLeft size={12} stroke={1.5} />
                <Box ml={5}>Back to login page</Box>
              </Center>
            </Anchor>
            <Button className={classes.control} onClick={onResetPasswordPress}>Reset password</Button>
          </Group>
        </Paper>

        <br /><br />
        {errorMessage ? <Alert color="red" title="Error">{errorMessage}</Alert> : null}
      </Container>
    );
}